import createConverter from './lib/create_converter';
import CustomerProfile from 'models/customer_profile';

export default createConverter(CustomerProfile);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/customer_profile_converter.js